<!-- products-list.component.html -->
<div class="container mx-auto px-2 sm:px-4 py-4 sm:py-6">
  <div class="flex flex-col lg:flex-row gap-4 sm:gap-6">
    <!-- Sidebar Filters -->
    <app-sidebar-filters
      [productsLength]="products.length"
      (filterChange)="onFilterChange($event)"
    ></app-sidebar-filters>

    <!-- Main Content -->
    <div class="lg:w-3/4 w-full order-1 lg:order-2">
      <!-- Products List -->
      <div class="products-list relative">
        <!-- Product List with Uniform Dimensions -->
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4 w-full max-w-6xl mx-auto p-2 sm:p-4" #productGrid>
          <!-- Skeleton Loader -->
          <ng-container *ngIf="productsLoading">
            <div
              *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36]"
              class="bg-gray-200 animate-pulse rounded-xl h-40 sm:h-48 md:h-56 overflow-hidden border border-gray-300"
            >
              <div class="w-full h-24 sm:h-32 md:h-36 bg-gray-300"></div>
              <div class="p-2 sm:p-3 space-y-1 sm:space-y-2">
                <div class="h-3 sm:h-4 bg-gray-300 rounded w-3/4"></div>
                <div class="h-3 sm:h-4 bg-gray-300 rounded w-1/3"></div>
                <div class="h-6 sm:h-8 bg-gray-300 rounded w-full mt-1 sm:mt-2"></div>
              </div>
            </div>
          </ng-container>

          <!-- Actual Products -->
          <ng-container *ngIf="!productsLoading">
            <app-my-item-product
              *ngFor="let product of displayedProducts"
              [product]="product"
              [displayMode]="'grid'"
            ></app-my-item-product>
          </ng-container>
          <!-- Sentinel element for Intersection Observer -->
          <div id="sentinel" class="h-1"></div>
        </div>
      </div>

      <!-- Optional: Keep Load More Button as Fallback -->
<!--
      <div *ngIf="!productsLoading && currentIndex < products.length" class="text-center mt-4 sm:mt-6">
        <button
          (click)="loadMore()"
          [disabled]="loadMoreLoading"
          class="px-4 sm:px-6 py-2 sm:py-3 bg-gold text-white rounded hover:bg-gold-dark transition-colors duration-300 disabled:opacity-50"
        >
          <span *ngIf="loadMoreLoading" class="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></span>
          Charger plus
        </button>
      </div>
-->

      <!-- Back to Top Button -->
      <button
        *ngIf="showBackToTop"
        (click)="scrollToTop()"
        class="fixed bottom-16 right-4 p-2 sm:p-3 bg-gold text-white rounded-full shadow-lg z-20 hover:bg-gold-dark transition-colors duration-300"
        aria-label="Back to Top"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
        </svg>
      </button>
    </div>
</div>

<!-- Filter Toggle Button (Mobile) -->
<button
  (click)="toggleFilters()"
  class="lg:hidden fixed bottom-4 right-4 p-2 sm:p-3 bg-gold text-white rounded-full shadow-lg z-20"
  aria-label="Toggle Filters"
>
  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 6a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2zm0 6a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2z"></path>
  </svg>
</button>
</div>
